import { render, staticRenderFns } from "./TextLocale.vue?vue&type=template&id=259063c1&scoped=true"
import script from "./TextLocale.vue?vue&type=script&lang=js"
export * from "./TextLocale.vue?vue&type=script&lang=js"
import style0 from "./TextLocale.vue?vue&type=style&index=0&id=259063c1&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "259063c1",
  null
  
)

export default component.exports